<script setup>
definePageMeta({
  theme: 'theme-lapiz',
  middleware: ['validate-session']
})

const config = useRuntimeConfig()
const { $api } = useNuxtApp()
const route = useRoute()
const page = computed(() => route.query.page || 1)
const tech = computed(() => route.query.tech || null)
const sort = computed(() => route.query.sort || 'desc')

const { data: articles, status } = await useAsyncData(
  async () => $api.get('articles', {
    page: page.value,
    tech: tech.value,
    sort: sort.value
  }), {
    watch: [page, tech, sort]
  }
)

const isLoading = computed(() => status.value === 'pending')

useHead(() => ({
  link: [
    {
      rel: 'canonical',
      href: [config.public.SEO_APP_ROOT, 'blog'].join('/')
    }
  ]
}))

const meta = {
  title: 'Certificates.dev Blog',
  description: 'The resource page to know all about the latest Certificates tips & tricks, industry news, and best practices'
}

useServerSeoMeta({
  title: meta.title,
  ogTitle: meta.title,
  description: meta.description,
  ogDescription: meta.description,
  ogImage: `${config.public.APP_ROOT}${meta.image}`,
  twitterCard: 'summary_large_image'
})
</script>

<template>
  <HomeHeader />
  <BlogHero />
  <BlogList
    class="transition-opacity"
    :class="{
      'pointer-events-none opacity-50': isLoading
    }"
    :articles="articles?.data" />
  <BlogPagination
    v-if="articles?.data.length && articles?.meta"
    :meta="articles?.meta" />
  <HomeTestimonial />
  <HomeFooter class="mt-24" />
</template>
